import { IAdsService } from "../../types/IAdsService";
import { IConfig } from "../../types/IConfig";
import { IBid, IProvider } from "../provider";

export class AsAdsService implements IAdsService {
  constructor() {
    const src = 'https://ak-ads-ns.prisasd.com/slot/as_juegos/slot.js';
    if (document.querySelector(`script[src='${src}']`)) {
      return;
    }
    const container = document.head || document.body;
    const script = Object.assign(document.createElement('script'), { src, defer: '' });
    container.appendChild(script);
  }

  public request(params: IConfig): Promise<IBid[]> {
    const createBid = (adUrl: string) => ({
      bid: { cpm: 0 },
      provider: this.createStubProvider(adUrl),
    });
    return new Promise(async (resolve, reject) => {
      setTimeout(() => resolve([]), 10000);
      const interval = setInterval(() => {
        if (!window.PBS) return;

        clearInterval(interval);

        document.addEventListener('AD_VIDEO_BID_RESPONSE', (event: any) => resolve([createBid(event.detail)]));
        const adUrl = window.PBS.fn.getVideoGptRequest({ vpmute: 0, vpa: 'click', pos: 'pre', playerType: 'arkadium', adType: 'audio_video', adunit: 'as_juegos_ext', returnPromise: false });
        setTimeout(() => resolve([createBid(adUrl)]), 2000);
      }, 500);
    }) as Promise<IBid[]>;
  }

  public retryRequest(): Promise<IBid[]> {
    return Promise.resolve([]);
  }

  public getBid(): Promise<{ cpm: number; bidder: string; url: string; }> {
    return Promise.reject();
  }

  public cleanup(): void {

  }

  protected createStubProvider(url: string): IProvider {
    return {
      name: 'pogo',
      configure() { },
      requestBids: () => Promise.resolve([]),
      buildVideoUrl: () => Promise.resolve(url),
      cleanup: () => null,
      setAdUnit: () => null,
    };
  }
}
